import { graphql } from '@/gql';
import type { CreateSavedGroceryByOrderIdMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const addSavedGrocery = async ({ orderId, name, type, notes }: CreateSavedGroceryByOrderIdMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation createSavedGroceryByOrderId($orderId: String!, $name: String!, $type: Float!, $notes: String) {
        createSavedGroceryByOrderId(orderId: $orderId, name: $name, type: $type, notes: $notes) {
          id
        }
      }
    `),
    variables: {
      orderId,
      type,
      name,
      notes,
    },
  });

  return !!response.data?.createSavedGroceryByOrderId;
};
